import * as React from 'react';
import * as styles from './styles.scss';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { observer } from 'mobx-react-lite';
import TimeStreamToolbox from './TimeStreamToolbox';
import TimeStreamZoomTools from './TimeStreamZoomTools';
import TimeStreamFeedback from './TimeStreamFeedback';
import { useCanvasConfig } from '../hooks/useCanvasConfig';
import { isUsingToolbox } from '../viewstate';

export default observer(function TimeStreamToolsLayer() {
    // Feedback button depends on OWA header, which we're not rendering in OPX scenarios.
    const hasHeaderFeedback = isHostAppFeatureEnabled('headerFeedback');
    const { enableFeedback } = useCanvasConfig();
    return (
        <div className={styles.toolsLayer}>
            {isUsingToolbox() && <TimeStreamToolbox />}
            {hasHeaderFeedback && enableFeedback && <TimeStreamFeedback />}
            <TimeStreamZoomTools />
        </div>
    );
});
